export default __webpack_public_path__ + "images/p5.jpg";